// extracted by mini-css-extract-plugin
export default {"cls1":"vHerGTggkxXfG74uQrcw","cls2":"e8gcFmSP69Ju6BDBrBRQ vHerGTggkxXfG74uQrcw"};